import {STEP_TYPE_TO_ICON} from 'graphql-client/__generated/GeneratedEnumMaps';
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

import {getIconForStepDataKindOrUndefined} from './RawStepDataKindRegistry';

export function getStepTypeIcon(stepType: PipelineStepType): BenchlingIconName | null {
  return STEP_TYPE_TO_ICON[stepType] as BenchlingIconName | null;
}

export function getStepTypeIconOrDefault(
  stepType: PipelineStepType,
  defaultIcon: BenchlingIconName
): BenchlingIconName {
  return getStepTypeIcon(stepType) ?? defaultIcon;
}

/** Fallback icon for a raw data kind that has no icon registered yet. */
const DEFAULT_STEP_DATA_KIND_ICON: BenchlingIconName = 'table';

export function getIconForStepDataKind(kind: PipelineStepDataKind): BenchlingIconName {
  return getIconForStepDataKindOrUndefined(kind) ?? DEFAULT_STEP_DATA_KIND_ICON;
}
